import { render, staticRenderFns } from "./compensation.vue?vue&type=template&id=23014e60&scoped=true"
import script from "./compensation.vue?vue&type=script&lang=js"
export * from "./compensation.vue?vue&type=script&lang=js"
import style0 from "./compensation.vue?vue&type=style&index=0&id=23014e60&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23014e60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23014e60')) {
      api.createRecord('23014e60', component.options)
    } else {
      api.reload('23014e60', component.options)
    }
    module.hot.accept("./compensation.vue?vue&type=template&id=23014e60&scoped=true", function () {
      api.rerender('23014e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aftersale/compensation.vue"
export default component.exports